/**
 *
 */
export enum Furnishings {
  Uncarpeted = 1,
  Unfurnished = 2,
  Furnished = 4,
}
